import { h, setChildren } from "../core/dom.js";
import { api } from "../api.js";
import { navigate } from "../core/router.js";
import { icon } from "../lib/icons.js";
import { toast } from "../components/ui.js";

// Landing screen for the password-reset link emailed to the user. The single-use token
// arrives in the URL fragment (#token=…) — never sent to a server until we POST it here.
export default function ResetPassword() {
  const root = h("div", { class: "auth reset-auth" });

  const params = new URLSearchParams(location.hash.replace(/^#/, ""));
  const token = params.get("token");
  history.replaceState({}, "", location.pathname); // strip the token from the address bar

  async function submit(e) {
    e.preventDefault();
    const f = new FormData(e.target);
    const pw = f.get("password");
    const confirm = f.get("confirm");
    const btn = e.target.querySelector("button[type=submit]");
    if (pw !== confirm) { toast("Passwords don't match", "error"); return; }
    btn.disabled = true;
    try {
      await api.resetPassword({ token, new_password: pw });
      toast("Password updated — please log in", "success");
      navigate("/login", { replace: true });
    } catch (err) {
      toast(err.message || "Couldn't reset password", "error");
      btn.disabled = false;
    }
  }

  function view() {
    if (!token) {
      return h("div", null,
        h("div", { class: "auth-logo" },
          h("div", { class: "mark" }, icon("dumbbell", { size: 34 })),
          h("h1", null, "Reset password"),
          h("p", null, "This link is missing or invalid.")
        ),
        h("button", { class: "btn btn-primary btn-block btn-lg", onClick: () => navigate("/login", { replace: true }) }, "Back to log in")
      );
    }
    return h("div", null,
      h("div", { class: "auth-logo" },
        h("div", { class: "mark" }, icon("dumbbell", { size: 34 })),
        h("h1", null, "Choose a new password")
      ),
      h("form", { class: "card", onSubmit: submit },
        h("div", { class: "field" }, h("label", null, "New password"), h("input", { class: "input", name: "password", type: "password", autocomplete: "new-password", required: true, minlength: 6 })),
        h("div", { class: "field" }, h("label", null, "Confirm password"), h("input", { class: "input", name: "confirm", type: "password", autocomplete: "new-password", required: true, minlength: 6 })),
        h("button", { class: "btn btn-primary btn-block btn-lg", type: "submit" }, "Update password")
      )
    );
  }

  setChildren(root, view());
  return root;
}
